import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./PauseOrderModal.css"
import {  useState } from 'react';
import Swal from "sweetalert2";

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";


const PauseOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [pauseCause, setPauseCause] = useState(null);
    
    const [objOrder, setObjOrder] = useState([]);


    const requestOrderInfo = async () =>{

        const endpoint = "getOrderByID?order_id=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();

        const metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);

    } //END FUNCTION


    const pauseOrder = async () => {

        //MAIN VALIDATION
        if(!pauseCause){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        const endpoint = "updateOrder?orderID=" + orderID;

         //
        const metadata = {
            "customer": objOrder.customer,
            "model": objOrder.model,
            "serialNumber":objOrder.serialNumber,
            "failure":objOrder.failure,
            "personContact":objOrder.personContact,
            "issuesDate": objOrder.issuesDate,
            "status": "Servicio en pausa",
            "address": objOrder.address,
            "tecnico": objOrder.tecnico,
            "technicalReport": objOrder.technicalReport,
            "serviceInvoice": objOrder.serviceInvoice,
            "personContactData": objOrder.personContactData,
            "notes":objOrder.notes
        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";

        //
        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE LOG INFORMATION
        storeOrderLog(orderID, sessionUser.customer_name, "Servicio Pausado", pauseCause ? pauseCause.replace(/[\t']/g, '') : "",);

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });

        //CLOSE MODAL
        requestClose(false);


    } //END FUNCTION

    return (
        <>
        <Modal show={show} onShow={requestOrderInfo}  onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Pasar Orden de Servicio | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12} style={{lineHeight: '20px'}}>
                        
                        <span className='closeOrderlabels'>Cliente: </span>
                        <span>{objOrder.customer} </span><br />

                        <span className='closeOrderlabels'>Modelo: </span>
                        <span>{objOrder.model} </span><br />

                        <span className='closeOrderlabels'>N° Serie: </span>
                        <span>{objOrder.serialNumber}</span><br />

                        <span className='closeOrderlabels'>Falla / Detalles: </span>
                        <span>{objOrder.failure}</span><br />

                        <span className='closeOrderlabels'>Persona Contacto: </span>
                        <span>{objOrder.personContact}</span><br />

                        <span className='closeOrderlabels'>Dirección del servicio: </span>
                        <span>{objOrder.address}</span><br />

                        <span className='closeOrderlabels'>Técnico: </span>
                        <span>{objOrder.tecnico}</span><br /><br />

                    </Col>
                    <hr />
                    
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Motivo de la Pausa del Servicio</Form.Label>
                             <Form.Control as="textarea" rows={5} onChange={(event)=> setPauseCause(event.target.value)}/><br />
                        </Form.Group>
                    </Col>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={pauseOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default PauseOrderModal;